import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { SketchPicker } from "react-color";
import { CircularProgress } from "@material-ui/core";
import "../styling/sidebar.css";
import "react-vis/dist/style.css";
import UserService from "../services/user-service";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import QuestionMark from "../assets/Icon/QuestionMark";
import Popover from "@mui/material/Popover";
import ProfitGraph from "./Charts/ProfitGraph";
import moment from "moment";

const ONE_DAY = 86400000;

const colors = [
  "#0E8C8C",
  "#7964D9",
  "#EB6F2D",
  "#98B514",
  "#0DA4B5",
  "#FFD436",
  "#FAAC02",
  "#EA4147",
  "#FC6897",
  "#006895",
];

function createData(name, date, amount, site, category, note) {
  return { name, date, amount, site, category, note };
}

function createData3(date, amount) {
  return { x: date.getTime(), y: amount };
}

function toX(value) {
  if (value && Object.keys(value).length > 0) {
    const date = new Date(value.x);
    return (
      date.toLocaleString("default", { month: "short" }) + " " + date.getDate()
    );
  }
}

function toY(value) {
  if (value && Object.keys(value).length > 0) {
    return "$" + value.y.toFixed(2);
  }
}

function getTotal(data, info) {
  const temp = {};
  const totalAmount: number[] = [];
  const max = info.source.length;
  for (let i = 1; i <= max; i++) {
    temp[i] = 0;
  }

  for (let i = 1; i <= max; i++) {
    const filtered = UserService.getSpecificExpense(data, i);
    temp[i] = filtered;
  }

  for (var item in temp) {
    totalAmount.push(temp[item]);
  }
  return totalAmount;
}
const rows = [
  createData(
    "Hand plane",
    "4/9/21",
    "$10.00",
    "Lowe's",
    "Workshop tools",
    "Replacement"
  ),
  createData("Oak 4 x 4 x 4", "4/21/21", "$37.00", "Lowe's", "Lumber", 0),
  createData(
    "Dado blade",
    "5/10/21",
    "$50.00",
    "Lowe's",
    "Workshop tools",
    "Drawer"
  ),
  createData("Sandpaper", "6/9/21", "$10.00", "Lowe's", "Supplies", "Bench"),
];

function ProfitLineChart(props) {
  const [, setToLoading] = useState(true);
  const [nrows, setnRows] = useState(rows);
  const [, setAlldata] = useState({});
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState("#000000");
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const openModel = Boolean(anchorEl);
  let count = 0;
  let minDate = new Date();
  let maxValue = 0;
  let minValue = 0;
  const allData = {};
  const dateArray: Date[] = [];
  let numDays = 0;
  let tempDate = new Date();

  const [dateArrayNew, setDateArrayNew] = useState<any[]>([]);

  useEffect(() => {
    const allDates = [] as any;
    if (props.dateList.length > 0) {
      props.dateList.map((item) => {
        !allDates.includes(String(item).slice(0, 15)) &&
          allDates.push(String(item).slice(0, 15));
      });
      setDateArrayNew(allDates);
    } else {
      var WeekDays = [] as any;
      var WeekDates = [] as any;
      var startOfWeek = moment().startOf("isoWeek");
      var endOfWeek = moment().endOf("isoWeek");
      while (startOfWeek <= endOfWeek) {
        WeekDays.push(startOfWeek.toDate());
        startOfWeek = startOfWeek.clone().add(1, "d");
      }
      WeekDays.map((item) => {
        !WeekDates.includes(String(item).slice(0, 15)) &&
          WeekDates.push(String(item).slice(0, 15));
      });
      setDateArrayNew(WeekDates);
    }
  }, [props.dateList]);

  useEffect(() => {
    UserService.getIncome().then((response) => {
      const data = response.data;
      count = data.source.length;
      setAlldata(data);
      UserService.getExpense().then((response) => {
        let expenses = getTotal(response.data.expense, data);
        if (props.stream <= count && props.stream >= 0) {
          const temp: any[] = [];
          temp.push(
            UserService.getSpecificExpense(response.data.expense, props.stream)
          );
          expenses = temp;
        }
        UserService.getSale().then((response) => {
          let sales = getTotal(response.data.sale, data);

          if (props.stream <= count && props.stream >= 0) {
            const temp: any[] = [];
            temp.push(
              UserService.getSpecificSale(response.data.sale, props.stream)
            );
            sales = temp;
          }
          const dataArray = UserService.makeIncomeArray(
            data.iname,
            data.source,
            data.income,
            data.note,
            expenses,
            sales
          );
          setLoading(false);
          setnRows(dataArray);
          setToLoading(false);
        });
      });
    });
    if (props.stream !== -1) {
      setColor(props.graphColor);
    }
  }, []);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  Array.from(nrows).map(function (e) {
    if (e["expenses"] != null) {
      for (let i = 0; i < e["expenses"].length; i++) {
        tempDate = new Date(e["expenses"][i]["date"]);
        if (!isNaN(tempDate.getTime())) {
          dateArray.push(tempDate);
        }
      }
    }
    if (e["sales"] != null) {
      for (let i = 0; i < e["sales"].length; i++) {
        tempDate = new Date(e["sales"][i]["date"]);
        if (!isNaN(tempDate.getTime())) {
          dateArray.push(tempDate);
        }
      }
    }
  });

  const maxDateF = (dateArray: Date[]) =>
    new Date(Math.max(...dateArray.map(Number)));
  const minDateF = (dateArray: Date[]) =>
    new Date(Math.min(...dateArray.map(Number)));
  let maxDay = maxDateF(dateArray);
  let minDay = minDateF(dateArray);
  if (props.range[0] != null && !isNaN(props.range[0])) {
    minDay = props.range[0];
  }
  if (props.range[1] != null && !isNaN(props.range[1])) {
    maxDay = props.range[1];
  }

  numDays = (maxDay.getTime() - minDay.getTime()) / ONE_DAY + 1;

  if (numDays > 12 && numDays <= 60) {
    numDays = 3;
  } else if (numDays > 60 && numDays < 365) {
    numDays = 6;
  } else if (numDays >= 365) {
    numDays = 12;
  }

  Array.from(nrows).map(function (e) {
    var dict = {};
    var amount_before = 0;
    if (e["expenses"] != null) {
      for (let i = 0; i < e["expenses"].length; i++) {
        let f = e["expenses"][i];
        const amount = -parseFloat(f["amount"]);
        const date = new Date(f["date"]);
        if (!isNaN(date.getTime())) {
          var val = null;
          amount_before = 0;
          for (let j = 0; j < e["expenses"].length; j++) {
            const curr_date = new Date(e["expenses"][j]["date"]);
            if (curr_date < date) {
              amount_before -= parseFloat(e["expenses"][j]["amount"]);
            }
          }
          if (e["sales"] != null) {
            for (let j = 0; j < e["sales"].length; j++) {
              const curr_date = new Date(e["sales"][j]["date"]);
              if (curr_date < date) {
                amount_before += parseFloat(e["sales"][j]["amount"]);
              }
            }
          }
          if (date < minDate) {
            minDate = date;
          }
          if (f.date in dict) {
            dict[f["date"]] = [date, dict[f["date"]][1] + amount];
          } else {
            dict[f["date"]] = [date, amount + amount_before];
          }
          if (dict[f["date"]][1] > maxValue) {
            maxValue = dict[f["date"]][1];
          }
          if (dict[f["date"]][1] < minValue) {
            minValue = dict[f["date"]][1];
          }
        }
      }
    }
    if (e["sales"] != null) {
      for (let i = 0; i < e["sales"].length; i++) {
        let f = e["sales"][i];
        const amount = parseFloat(f["amount"]);
        const date = new Date(f["date"]);
        if (!isNaN(date.getTime())) {
          var val = null;
          amount_before = 0;

          if (e["expenses"] != null) {
            for (let j = 0; j < e["expenses"].length; j++) {
              const curr_date = new Date(e["expenses"][j]["date"]);
              if (curr_date < date) {
                amount_before -= parseFloat(e["expenses"][j]["amount"]);
              }
            }
          }
          for (let j = 0; j < e["sales"].length; j++) {
            const curr_date = new Date(e["sales"][j]["date"]);
            if (curr_date < date) {
              amount_before += parseFloat(e["sales"][j]["amount"]);
            }
          }
          if (date < minDate) {
            minDate = date;
          }
          if (f.date in dict) {
            dict[f["date"]] = [date, dict[f["date"]][1] + amount];
          } else {
            dict[f["date"]] = [date, amount + amount_before];
          }
          if (dict[f["date"]][1] > maxValue) {
            maxValue = dict[f["date"]][1];
          }
          if (dict[f["date"]][1] < minValue) {
            minValue = dict[f["date"]][1];
          }
        }
      }
    }
    if (Object.keys(dict).length > 0) {
      let temp = e["name"];
      dict = Object.keys(dict).reduce(function (filtered, key) {
        let temp = new Date(key);
        if (temp >= minDay && temp <= maxDay) filtered[key] = dict[key];
        return filtered;
      }, {});
      allData[temp] = dict;
    }
  });
  if (nrows.length == 0) {
    return <div></div>;
  }

  let list = Object.keys(allData).map((nrow) =>
    Object.keys(allData[nrow])
      .map((data) =>
        createData3(allData[nrow][data][0], allData[nrow][data][1])
      )
      .sort((data_a, data_b) => data_a.x - data_b.x)
  );
  let list2 = [] as any;
  for (let i = 0; i < list.length; i++) {
    for (let j = 0; j < list[i].length; j++) {
      list2.push(list[i][j] || {});
    }
  }

  const handleChangeComplete = (color) => {
    let colorStr = color.hex
    if(color.rgb.a !== 1){
      colorStr = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
    }
    setColor(colorStr);
  };

  return (
    <>
      {loading ? (
        <CircularProgress className="graph-loader" />
      ) : (
        <>
          {!props.showErrorMessage ? (
            <div className="graph-container">
              <ProfitGraph
                dateList={dateArrayNew.sort(function (a, b) {
                  // @ts-ignore
                  return new Date(a) - new Date(b);
                })}
                allData={allData}
                stream={props.stream}
                color={color}
              />
            </div>
          ) : (
            <div className="graph-container">
              <ProfitGraph
                dateList={dateArrayNew.sort(function (a, b) {
                  // @ts-ignore
                  return new Date(a) - new Date(b);
                })}
                allData={allData}
                stream={props.stream}
                color={color}
              />
            </div>
          )}
          {!props.showErrorMessage && props.streamName?.length > 0 && (
            <Row className="color-picker-row">
              <Col>
                <div className="color-picker-block">
                  <div className="d-flex justify-content-start ml-5">
                    <div className="sketch-color">
                      {open && (
                        <SketchPicker
                          className="sketch-picker"
                          color={color}
                          onChangeComplete={handleChangeComplete}
                        />
                      )}
                    </div>
                    <div className="d-flex justify-content-center align-items-center color-picker">
                      <span
                        onClick={() => setOpen(!open)}
                        style={{ backgroundColor: color }}
                        className="card-color"
                      ></span>
                      <span
                        className="stream-name"
                        onClick={() => setOpen(!open)}
                        style={{ color: color, marginLeft: 14 }}
                      >
                        {props.streamName ? `${props.streamName}` : "Profit"}
                      </span>
                    </div>
                    <div className="my-3">
                      <Box>
                        <Typography
                          aria-owns={
                            openModel ? "mouse-over-popover" : undefined
                          }
                          aria-haspopup="true"
                          onMouseEnter={handlePopoverOpen}
                          onMouseLeave={handlePopoverClose}
                        >
                          <QuestionMark className="ml-3" />
                        </Typography>
                        <Popover
                          id="mouse-over-popover"
                          sx={{
                            pointerEvents: "none",
                          }}
                          open={openModel}
                          anchorEl={anchorEl}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          className="ml-2"
                          onClose={handlePopoverClose}
                          disableRestoreFocus
                        >
                          <Typography
                            sx={{ p: 1 }}
                            className="text-white bg-dark"
                          >
                            Click the box to select a color
                          </Typography>
                        </Popover>
                      </Box>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </>
      )}
    </>
  );
}
export default ProfitLineChart;
